import { useEffect, useState } from "react";
import { Code2, Users, Save, UserPlus } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const blank = { email: "", password: "", name: "", role: "staff", is_active: true };

export default function AdminStaff() {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState(blank);
  const [loading, setLoading] = useState(false);

  const fetchUsers = async () => {
    const { data } = await api.get("/admin/users");
    setUsers(data.users || []);
  };
  useEffect(() => { fetchUsers(); }, []);

  const createUser = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/admin/users", form);
      toast.success("Staff ditambahkan.");
      setForm(blank);
      fetchUsers();
    } catch { toast.error("Gagal menyimpan staff."); }
    finally { setLoading(false); }
  };

  const updateUser = async (u, patch) => {
    const body = { email: u.email, name: u.name, role: u.role, is_active: u.is_active, ...patch };
    await api.put(`/admin/users/${u.id}`, body);
    toast.success("Akun diperbarui.");
    fetchUsers();
  };

  const disableUser = async (id) => {
    await api.delete(`/admin/users/${id}`);
    toast.success("Akun dinonaktifkan.");
    fetchUsers();
  };

  return (
    <div className="p-4 pt-16 sm:p-8 lg:p-12 max-w-6xl mx-auto animate-fade-up">
      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-cyan-400/10 text-cyan-600 text-xs font-semibold mb-3"><Code2 className="w-3.5 h-3.5" /> DEV</div>
      <h1 className="font-display text-4xl font-medium c-strong mb-2">Kelola Staff</h1>
      <p className="text-sm c-muted mb-6">Tambah, edit, dan nonaktifkan akun staff.</p>

      <form onSubmit={createUser} className="c-card border rounded-xl p-5 card-elev mb-6 grid grid-cols-1 md:grid-cols-5 gap-3">
        <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Nama" className="border c-input rounded-lg px-3 py-2 text-sm" />
        <input required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Username/email" className="border c-input rounded-lg px-3 py-2 text-sm" />
        <input value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Password (default staff123)" className="border c-input rounded-lg px-3 py-2 text-sm" />
        <select value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} className="border c-input rounded-lg px-3 py-2 text-sm"><option value="staff">Staff</option><option value="developer">Developer</option></select>
        <button disabled={loading} className="bg-gold text-white rounded-lg px-4 py-2 text-sm flex items-center justify-center gap-2"><UserPlus className="w-4 h-4" /> Tambah</button>
      </form>

      <div className="c-card border rounded-xl card-elev overflow-hidden">
        <table className="w-full text-sm text-left">
          <thead className="c-soft c-muted text-xs uppercase tracking-wider"><tr><th className="px-5 py-3">Nama</th><th className="px-5 py-3">Akun</th><th className="px-5 py-3">Role</th><th className="px-5 py-3">Status</th><th className="px-5 py-3">Aksi</th></tr></thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-t c-border">
                <td className="px-5 py-3"><input defaultValue={u.name} onBlur={(e) => e.target.value !== u.name && updateUser(u, { name: e.target.value })} className="border c-input rounded px-2 py-1 text-sm" /></td>
                <td className="px-5 py-3 c-muted">{u.email}</td>
                <td className="px-5 py-3"><select value={u.role} onChange={(e) => updateUser(u, { role: e.target.value })} className="border c-input rounded px-2 py-1 text-sm"><option value="staff">staff</option><option value="developer">developer</option></select></td>
                <td className="px-5 py-3"><span className={`px-2 py-1 rounded-full text-xs ${u.is_active ? "bg-emerald-500/10 text-emerald-600" : "bg-red-500/10 text-red-600"}`}>{u.is_active ? "Aktif" : "Nonaktif"}</span></td>
                <td className="px-5 py-3 flex gap-2"><button onClick={() => updateUser(u, {})} className="text-gold flex items-center gap-1"><Save className="w-4 h-4" /> Simpan</button><button onClick={() => disableUser(u.id)} className="text-red-600">Nonaktifkan</button></td>
              </tr>
            ))}
            {users.length === 0 && <tr><td colSpan={5} className="px-5 py-12 text-center c-muted"><Users className="w-8 h-8 mx-auto mb-2 text-gold" />Belum ada akun.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
